import { Dto } from '@damofire/data-commons';
import { Observer, Subject, Subscription } from 'rxjs';
import { WarehouseSyncExecutor } from './steps/warehouse-sync.executor';
import { Preference, PictureSyncRiskFilter } from '@damofire/data-stas';

export type WarehouseSyncStepStatus = 'PENDING' | 'RUNNING' | 'DONE' | 'ERROR';
export type WarehouseSyncStep = 0 | 1 | 2;
export const WAREHOUSE_SYNC_STEP_PUSH = 0;
export const WAREHOUSE_SYNC_STEP_DOWNLOAD = 1;
export const WAREHOUSE_SYNC_STEP_CLEAN = 2;
export const WAREHOUSE_SYNC_STEPS: WarehouseSyncStep[] = [WAREHOUSE_SYNC_STEP_PUSH, WAREHOUSE_SYNC_STEP_DOWNLOAD, WAREHOUSE_SYNC_STEP_CLEAN];

export interface WarehouseSyncStepParams {
  division: string;
  steps: WarehouseSyncStep[];
  environment: unknown;
  userPreferences: Preference<unknown>[];
}

export interface WarehouseSyncContext {
  warehouse: string;
  executor?: WarehouseSyncExecutor;
  nextSyncInterval: number;
  executorSubscription?: Subscription;
}

export interface ProgressStats {
  expected?: number | null;
  processed?: number;
}

export type ProgressCallback = (progress: number, stats?: ProgressStats) => void;

export interface WarehouseSyncStepTaskContext extends Dto<string> {
  syncId: string;
  step: WarehouseSyncStep;
  division: string;
  task: string;
  taskInx: number;
  progress: number;
  expected?: number | null;
  processed?: number;
  status: WarehouseSyncStepStatus;
  when: number;
  picturesRiskLevelFilter?: PictureSyncRiskFilter[] | null;
}

export interface WarehouseSyncStepContext extends Dto<string> {
  syncId: string;
  step: WarehouseSyncStep;
  division: string;
  task: string;
  tasks: number;
  taskInx: number;
  status: Record<number, WarehouseSyncStepStatus>;
  when: number;
}

export type WarehouseSyncStepContextEventName =
  | 'TASK_STARTED'
  | 'TASK_PROGRESSED'
  | 'TASK_FINISHED'
  | 'TASK_ERROR'
  | 'STEP_CANCELLED'
  | 'STEP_PROGRESS'
  | 'STEP_FINISHED'
  | 'STEP_ERROR'
  | 'SYNC_FINISHED'
  | 'SYNC_CANCELLED';
export interface WarehouseSyncStepContextEvent {
  ctx: Partial<WarehouseSyncStepContext | WarehouseSyncStepTaskContext>;
  event: WarehouseSyncStepContextEventName;
  err?: string;
}

export interface WarehouseSyncStepTask {
  name: () => string;
  execute: (ctx: WarehouseSyncStepTaskContext, listener: Observer<WarehouseSyncStepContextEvent>, taskBreaker: Subject<boolean>) => Promise<void>;
}
